import { render, staticRenderFns } from "./iamResult.vue?vue&type=template&id=b38bb0b0&scoped=true&"
import script from "./iamResult.vue?vue&type=script&lang=js&"
export * from "./iamResult.vue?vue&type=script&lang=js&"
import style0 from "./iamResult.vue?vue&type=style&index=0&id=b38bb0b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38bb0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
